import { useEffect } from "react";
import { CommissionModalHeader } from "./CommissionModalHeader";
import { CommissionModalFormWrapper } from "./CommissionModalFormWrapper";

const CommissionModal = ({
  selectedListingId,
  setSelectedListingId,
  setOpenCommissionModal,
  openCommissionModal,
  listing,
  getListing,
}) => {
  useEffect(() => {
    document.body.classList.add("modal-open");

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered mw-700px">
          {/* begin::Modal content */}
          <div className="modal-content">
            <CommissionModalHeader
              setSelectedListingId={setSelectedListingId}
              setOpenCommissionModal={setOpenCommissionModal}
            />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y mx-5 mx-xl-5 my-2 p-4">
              <CommissionModalFormWrapper
                selectedListingId={selectedListingId}
                setSelectedListingId={setSelectedListingId}
                openCommissionModal={openCommissionModal}
                setOpenCommissionModal={setOpenCommissionModal}
                listing={listing}
                getListing={getListing}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};

export { CommissionModal };
